import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';

import bannerLogo from '../images/Jook_Web_White.png';
import { authContext } from '../contexts/AuthContext';

import './JukeboxView.scss';
import './AppHeader.scss';

interface AppHeaderProps {
  /** Home is where the back link goes, so home itself leaves it out. */
  back?: boolean;
}

/**
 * The same bar along the top of every signed-in screen: back to home on the left, the logo
 * on the right. Jookable's own admins also get a way back to the dashboard from anywhere
 * but home, which has its own button for it.
 */
const AppHeader = ({ back = true }: AppHeaderProps) => {
  const context = useContext(authContext);
  const { pathname } = useLocation();
  const signedIn = !!(context.auth && context.auth.id);
  const isSiteAdmin = signedIn && !!context.currentUser && context.currentUser.role === 'admin';

  return (
    <div className="jukebox-header app-header">
      {back ? (
        <Link className="jukebox-back" to={signedIn ? '/home' : '/'}>
          <FontAwesomeIcon icon={faChevronLeft} /> {signedIn ? 'Home' : 'Sign in'}
        </Link>
      ) : (
        <span />
      )}
      <div className="app-header-right">
        {isSiteAdmin && pathname !== '/admin' && pathname !== '/home' && (
          <Link className="app-header-dashboard" to="/admin">
            Dashboard
          </Link>
        )}
        <Link to={signedIn ? '/home' : '/'} aria-label="Jookable home">
          <img className="jukebox-logo" src={bannerLogo} alt="Jookable" />
        </Link>
      </div>
    </div>
  );
};

export default AppHeader;
